export default __webpack_public_path__ + "static/media/image-4.7900eb92.png";